import { render, staticRenderFns } from "./AgreementPP.vue?vue&type=template&id=69a8c220"
import script from "./AgreementPP.vue?vue&type=script&lang=js"
export * from "./AgreementPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports